import React from "react";

interface DrawerProps {
  children: any;
  isOpen: boolean;

  setIsOpen(data: boolean): void;
}

const Drawer: React.FC<DrawerProps> = ({ children, isOpen, setIsOpen }) => {
  return (
    <main
      className={
        "fixed inset-0 transform overflow-hidden bg-gray-900 bg-opacity-25 ease-in-out z-[1251]" +
        (isOpen
          ? " translate-x-0 opacity-100 transition-opacity duration-500 "
          : " translate-x-full opacity-0 transition-all delay-500  ")
      }
    >
      <section
        className={
          "delay-400 absolute right-0 h-full w-screen max-w-lg transform shadow-xl transition-all duration-500 ease-in-out  " +
          (isOpen ? " translate-x-0 " : " translate-x-full ")
        }
        style={{ backgroundColor: "#40BA77" }}
      >
        <article className="relative flex h-full w-screen max-w-lg flex-col space-y-6 overflow-y-scroll pb-10">
          {/*<header className="p-4 text-lg font-bold">Header</header>*/}
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            // className="p-4 text-lg font-bold"
            className="absolute top-2.5 right-2.5 inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-white"
          >
            <svg
              aria-hidden="true"
              className="h-5 w-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          {children}
        </article>
      </section>
      <section
        className="h-full w-screen cursor-pointer"
        onClick={() => {
          setIsOpen(false);
        }}
      ></section>
    </main>
  );
};

export default Drawer;
